// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7776 ? "477d4af2" : chunkId) + "." + {"5539":"488e8a5c5e49bb46","7776":"16a5abfeb77264ee","7920":"d85d5a5d0281ac70","8448":"22d312837e8b8ba1"}[chunkId] + ".js";
};